import { RECENTLY_APPLIED_FILTERS } from "../../constants/app-constants";
import parseCookie from "./parse-cookie";
import saveCookie from "./save-cookie";

export const updateSavedFilters = (existingFilters = []) => {
    const savedFilters = JSON.parse(parseCookie(RECENTLY_APPLIED_FILTERS)) || [];
    const savedFiltersOptionKeys = savedFilters.map(({ optionKey = "" }) => optionKey) || [];
    const unsavedFilters = existingFilters.filter(({ optionKey = "" }) => optionKey && !savedFiltersOptionKeys.includes(optionKey));
    const updatedSavedFilters = [...savedFilters, ...unsavedFilters];
    saveCookie(RECENTLY_APPLIED_FILTERS, JSON.stringify(updatedSavedFilters));
    return updatedSavedFilters;
};
